module.exports = __webpack_public_path__ + "img/wallace-logo.2c93644a.jpg";